import React from 'react';

type StatusType = 'active' | 'arrived' | 'settled' | 'pending' | 'closed' | 'graded' | 'partial';

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
}

const STATUS_CONFIG: Record<StatusType, { label: string; className: string }> = {
  active: { label: 'Active', className: 'badge-status-active' },
  arrived: { label: 'Arrived', className: 'badge-status-arrived' },
  settled: { label: 'Settled', className: 'badge-status-settled' },
  pending: { label: 'Pending', className: 'badge-status-pending' },
  closed: { label: 'Closed', className: 'badge-status-closed' },
  graded: { label: 'Graded', className: 'bg-purple-500/10 text-purple-400 border border-purple-500/20 inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold' },
  partial: { label: 'Partial', className: 'bg-orange-500/10 text-orange-400 border border-orange-500/20 inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold' },
};

export default function StatusBadge({ status, label }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return (
    <span className={config.className}>
      {label || config.label}
    </span>
  );
}